import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
//import { getAuctioneerLotDetails, getDefaultAuthToken } from '../../Api';
import Moment from 'react-moment';
import DataTable from '../DataTable';
import useApi from '../../api/useApi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import lotImage from '../../images/lot.png'
import coloredLotImage from '../../images/lot-colored2.png'
import specialLotImage from '../../images/lot-special.png'
import lotSoldImage from '../../images/lot-sold.png'
import lotWithdrawnImage from '../../images/lot-withdrawn.png'
import specialLotSkipImage from '../../images/lot-special-skip.png'
import specialLotSoldImage from '../../images/lot-special-sold.png'
import specialLotWithtdrawnImage from '../../images/lot-special-withdrawn.png'
import lotSkipImage from '../../images/lot-skip.png'
import suspectedLotImage from '../../images/lot-yellow.png'
import { Draggable } from "react-drag-reorder";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { Button, Popover, OverlayTrigger, Overlay } from "react-bootstrap";

const LotOverview = () => {
    const navigate = useNavigate();
    const [lotSummary, setLotSummary] = useState({});
    const [selectedLot, setSelectedLot] = useState({});
    const [inputError, setInputError] = useState(false);
    const [suspectedLotCount, setSuspectedLotCount] = useState(0);
    const [coloredLotCount, setColoredLotCount] = useState(0);
    const [skippedLotCount, setSkippedLotCount] = useState(0);
    const [specialLotCount, setSpecialLotCount] = useState(0);
    const [lotDetailsData, setLotDetailsData] = useState([]);
    const [test, setTestData] = useState([1, 2, 3, 4, 5, 6]);
    const { id } = useParams();
    const api = useApi();

    const loadLots = async () => {
        try {
            let lotData = await api.getAuctioneerLots(id);
            setLotDetailsData(lotData?.lotDetail);
            lotData.lotDetail = null;
            setLotSummary(lotData);


        } catch (error) {
            console.log(error);
            alert('Unable to fetch lot detail data.');
        }
    };

    useEffect(() => {

        const _suspectedLotCount = lotDetailsData.reduce((count, lot) => {
            return count + (lot.isSuspectedLot ? 1 : 0);
        }, 0);

        const _coloredLotCount = lotDetailsData.reduce((count, lot) => {
            return count + (lot.isColoredLot ? 1 : 0);
        }, 0);

        const _skippedLotCount = lotDetailsData.reduce((count, lot) => {
            return count + (lot.status === 7 ? 1 : 0);
        }, 0);

        const _specialLotCount = lotDetailsData.reduce((count, lot) => {
            return count + (lot.isSpecialLot ? 1 : 0);
        }, 0);


        setSpecialLotCount(_specialLotCount);
        setSuspectedLotCount(_suspectedLotCount);
        setColoredLotCount(_coloredLotCount);
        setSkippedLotCount(_skippedLotCount);

    }, [lotDetailsData]);

    const updateLotSkip = async (lot) => {
        try {
            await api.updateLotSkip(lot).then((response) => {
                if (response.success) {
                    loadLots();
                    alert(response.message);
                }
                else
                    alert(response.message);
            }).catch((error) => {
                console.error('Unable to update lot data', error);
            });
        } catch (error) {
            alert('Unable to update lot data.');
        }
    }

    const onSkipLot = async (isSkip) => {
        debugger
        if (selectedLot) {
            setInputError(false);

            setSelectedLot(prevState => ({ ...prevState, status: isSkip ? 7 : 0 }));
            updateLotSkip({ ...selectedLot, status: isSkip ? 7 : 0 });
            setTimeout(() => {
                document.body.click();
            }, 100)
        }
    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">Lot Number : {selectedLot.lotNumber}</Popover.Header>
            <Popover.Body>
                {selectedLot.status !== 7 ? <button type="button" className="btn btn-outline-info btn-sm" onClick={() => onSkipLot(true)}>Skip this Lot</button> : null}
                {selectedLot.status === 7 ? <button type="button" className="btn btn-outline-success btn-sm" onClick={() => onSkipLot(false)}>Un Skip this Lot</button> : null}
            </Popover.Body>
        </Popover>
    );


    useEffect(() => {
        loadLots();
    }, []);

    const updateLotStatus = (e, lotId, status) => {

        e.preventDefault();
        const updatedLotDetailsData = lotDetailsData.map((lot) =>
            lot.lotId === lotId ? { ...lot, lotType: status } : lot
        );

        // Update the state with the modified array
        setLotDetailsData(updatedLotDetailsData);
    }

    const saveLotDetail = () => {

        const lotPriceData = lotDetailsData.map(t => {
            return {
                lotId: t.lotId,
                auctionId: t.auctionId,
                auctionStartPriceRs: t.auctionStartPriceRs,
                reservedPrice: t.reservedPrice,
            }
        })
        console.log(lotDetailsData)
        //api.saveLotPrice(lotPriceData)
        //    .then((response) => {
        //        fetchDataFromApi();
        //        alert("Record updated successfully");
        //    })
        //    .catch((error) => {
        //        // Handle error
        //        console.error('Error saving lot price data:', error);
        //    });
    };

    const onLotSelected = (lot) => {
        setInputError(false);
        setSelectedLot(lot)
    }

    const renderProductGrid = (lot, index) => {
        return (

            lot.isSuspectedLot === false && lot.isColoredLot === false ?
                <OverlayTrigger  //RENDER  CLICKABLE
                    key={index}
                    trigger="click"
                    placement="top"
                    overlay={popover}
                    rootClose={true}
                >
                    <div key={index}
                        className="product-grid"
                        onClick={() => onLotSelected(lot)}
                    >
                        <div className={(lot.status === 6 || lot.status === 7 || lot.status === 8 || lot.status === 9) ? "empty-bag-font product-image bd popover-bag-container" :"product-image bd popover-bag-container"}>
                            {
                                lot.isColoredLot ?
                                    <img className="pic-1" alt="product1" src={coloredLotImage} />
                                    : lot.isSuspectedLot ?
                                        <img className="pic-1" alt="product1" src={suspectedLotImage} />
                                        : lot.isSpecialLot && lot.status === 7 ?
                                            <img className="pic-1" alt="product1" src={specialLotSkipImage} />
                                            : lot.isSpecialLot && lot.status === 8 ?
                                                <img className="pic-1" alt="product1" src={specialLotSoldImage} />
                                                : lot.isSpecialLot && lot.status === 6 ?
                                                    <img className="pic-1" alt="product1" src={specialLotWithtdrawnImage} />
                                                    : lot.isSpecialLot ?
                                                        <img className="pic-1" alt="product1" src={specialLotImage} />
                                                        : lot.status === 6 ?
                                                            <img className="pic-1" alt="product1" src={lotWithdrawnImage} />
                                                            : lot.status === 7 ?
                                                                <img className="pic-1" alt="product1" src={lotSkipImage} />
                                                                : lot.status === 8 ?
                                                                    <img className="pic-1" alt="product1" src={lotSoldImage} />
                                                                    : <img className="pic-1" alt="product1" src={lotImage} />
                            }
                            <span >{lot.lotNumber}</span>
                        </div>
                    </div>
                </OverlayTrigger>
                : //RENDER NON CLICKABLE
                <div
                    key={index}

                >
                    <div key={index}
                        className="product-grid"
                    >
                        <div className="product-image bd popover-bag-container">
                            {
                                lot.isColoredLot ?
                                    <img className="pic-1" alt="product1" src={coloredLotImage} />
                                    : lot.isSuspectedLot ?
                                        <img className="pic-1" alt="product1" src={suspectedLotImage} />
                                        : lot.isSpecialLot ?
                                            <img className="pic-1" alt="product1" src={specialLotImage} />
                                            : <img className="pic-1" alt="product1" src={lotImage} />
                            }
                            <span>{lot.lotNumber}</span>
                        </div>
                    </div>
                </div>
        );
    };


    return (
        <div>
            <div className="inner-body mg-t-30">
                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div className="border-bottom-0 mg-b-10">
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <label className="main-content-label mb-2">Lot bag view</label>
                                            <span className="d-block tx-12 mb-0 text-muted">Hover and click on the lot to view action item. You can update the status of the lot here.</span>
                                        </div>
                                        <div className="d-flex justify-content-around mg-t-4">
                                            <div className="me-4">
                                                <span class="me-1 badge rounded-pill bg-primary">{specialLotCount}</span>
                                                <span>Speical Lots</span>
                                            </div>
                                            <div className="me-4">
                                                <span className="me-1 badge rounded-pill text-dark bg-light">{skippedLotCount}</span>
                                                <span>Skipped Lots</span>
                                            </div>
                                            <div className="me-4">
                                                <span className="me-1 badge rounded-pill bg-warning-dark">{suspectedLotCount}</span>
                                                <span>Suspected Lots</span>
                                            </div>
                                            <div className="me-3">
                                                <span className="me-1 badge rounded-pill bg-danger-dark" >{coloredLotCount}</span>
                                                <span>Colored Lots</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                                {lotDetailsData?.length === 0 ?
                                    <div className="wd-20p">
                                        <span>Please wait...</span>
                                        <Skeleton containerClassName="" height={16} count={1} />
                                    </div> : null}

                                <div className="d-flex flex-wrap ht-400 overflow-auto">
                                    {lotDetailsData?.map((t, index) => renderProductGrid(t, index))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );


}


export default LotOverview;